import Availabilities from '@/api/availabilities'

export default {
  props: {
    experts: {
      type: Array,
      required: true
    }
  },
  computed: {
    hoursPerDay () {

    },
    hoursPerWeekDay () {
      return Availabilities.hoursPerWeekDay(this.experts)
    },
    maxHours () {
      return Availabilities.maxHourPerDay(this.experts)
    },
    totalHoursPerDay () {
      return Availabilities.totalHoursPerDay(this.experts)
    }
  },
  methods: {
    sumHours (hours) {
      return hours.reduce((sum, hour) => sum + hour, 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/availabilitiesTable.js